import { memo } from 'react';
import { useAuthMe } from 'view/pages/auth/hooks/useAuthMe';

export const GlobalConfigContainer = memo((): null => {
  const path = window.location.pathname === '/auth/socialLogin';
  if (!path) useAuthMe(true);
  return null;
});
